import { cn } from "@/utils";
import type { LucideIcon } from "lucide-react";
import React from "react";

export interface WorkspaceHeaderButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: LucideIcon;
  label: string;
  pressed?: boolean;
}

/** Shared header glyph button — size-8 (32px), rounded-md, rust focus ring. */
export const WorkspaceHeaderButton = React.forwardRef<
  HTMLButtonElement,
  WorkspaceHeaderButtonProps
>(function WorkspaceHeaderButton(
  { icon: Icon, label, pressed, onClick, className, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      aria-pressed={pressed}
      aria-label={label}
      title={label}
      className={cn(
        "inline-flex size-8 shrink-0 items-center justify-center rounded-md text-n-50 outline-none transition-colors hover:bg-n-05 hover:text-n-80 focus-visible:outline-2 focus-visible:outline-rust focus-visible:outline-offset-[-2px]",
        pressed && "bg-n-10 text-n-90 hover:bg-n-10 hover:text-n-90",
        className,
      )}
      {...props}
    >
      {children ?? <Icon className="size-4" />}
    </button>
  );
});
